import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
  margin-left: 10px;
`;

const Action = styled.div`
  cursor: pointer;
  color: #bebebe;
`;

export { Container, Content, Title, Action };
